import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Badge, Tooltip } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

type ScoringRuleUsedBadgeProps = {
    playbookNames?: readonly string[];
};

export const ScoringRuleUsedBadge = ({ playbookNames = [] }: ScoringRuleUsedBadgeProps) => {
    const { translate } = useTranslate();

    const badge = (
        <Flex
            width="fit-content"
            data-automation="scoring-rule-card.used-badge"
        >
            <Badge
                bgColor={colorsPalettes.yellow["100"]}
                color={colorsPalettes.yellow["700"]}
                type="custom"
            >
                {translate("si.playbooks.scoring_rule.used.label")}
            </Badge>
        </Flex>
    );

    if (playbookNames.length === 0) {
        return badge;
    }

    const tooltipContent = (
        <Stack
            gap="4px"
            maxWidth="280px"
            data-automation="scoring-rule-used-tooltip"
        >
            <Text
                fontVariant="listItem1"
                color={colorsPalettes.carbon["0"]}
            >
                {translate("si.playbooks.scoring_rule.used.tooltip")}
            </Text>
            {playbookNames.map((name, index) => (
                <Flex
                    key={`${name}-${index}`}
                    gap="6px"
                    alignItems="flex-start"
                >
                    <Text
                        fontVariant="tooltip"
                        color={colorsPalettes.carbon["0"]}
                    >
                        •
                    </Text>
                    <Text
                        fontVariant="tooltip"
                        color={colorsPalettes.carbon["0"]}
                    >
                        {name}
                    </Text>
                </Flex>
            ))}
        </Stack>
    );

    return (
        <Tooltip
            placement="top"
            content={tooltipContent}
        >
            {badge}
        </Tooltip>
    );
};
